import {
  MENU_FOLD_OUT,
  MENU_UNFOLD_OUT,
  SIDER_BREAKPOINT_FOLD,
  SIDER_BREAKPOINT_UNFOLD,
} from '../app/constant'

const INITIAL_STATE = {
  siderWidth: 265,
  siderCollapsed: false,
  onBreakpointCollapsed: false,
}

export default function styleReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case MENU_FOLD_OUT:
      return {
        ...state,
        siderWidth: 18,
        siderCollapsed: false
      }
    case MENU_UNFOLD_OUT:
      return {
        ...state,
        siderWidth: 265,
        siderCollapsed: true
      }
    case SIDER_BREAKPOINT_FOLD:
      return {
        ...state,
        onBreakpointCollapsed: true
      }
    case SIDER_BREAKPOINT_UNFOLD:
      return {
        ...state,
        onBreakpointCollapsed: false
      }
    default:
      return state
  }
}
